import * as _ from "lodash";
import { Cases } from "../definitions/Cases";
import { SimpleCaseModel } from "../model/MutationModels";

export class ProviderMapping {
  static simpleCase(data: any, category: string) {
    try {
      const obj = new SimpleCaseModel({
        category: category,
        type: "",
        subtype: "",
        ...data,
      });
      return _.pickBy(obj, _.identity);
    } catch (e) {
      console.log(e);
    }
  }
  static complexCase(
    data: any,
    category: string,
    excludeProperties: boolean,
    contracts: any[]
  ) {
    interface CaseOutput {
      translatedMapping?: any;
    }
    console.log(data, excludeProperties, "mappingData");
    try {
      /**
       * Abbiamo aggiunto un campo "subType". Questo campo deve essere passato quando type === "SEWER_CONNECTION" OPPURE type === "AQUEDUCT_CONNECTION".
       In particolare:
       - quando type === "SEWER_CONNECTION", subType può assumere SOLO i seguenti valori SEWER, SEWER_EXT
       - quando type === "WATER_CONNECTION", subType può assumere SOLO i seguenti valori WATER, WATER_EXT
       */

      let { translatedMapping } = Cases[
        category as keyof typeof Cases
      ]() as CaseOutput;
      if (!translatedMapping) {
        translatedMapping = (props: any) => props;
      }
      const callTranslatedMapping = (data: any, excludeProperties: boolean) => {
        if (excludeProperties) {
          return translatedMapping(data, excludeProperties);
        } else if (contracts.length !== 0) {
          return translatedMapping(data, contracts);
        } else {
          console.log("hellooooooooooooooooooo");
          return translatedMapping(data);
        }
      };
      const r = callTranslatedMapping(data, excludeProperties);
      if (data.caseId) {
        r.caseId = data.caseId;
        console.log(`Updating case (${data.caseId}) - ${category}`, r);
      }
      // return _.pickBy(translatedMapping(data), _.identity);
      return r;
    } catch (e) {
      console.log(e);
    }
  }
}
